import { GridTable } from "@ctsu/ctsu-mui-grid";
import { getToken } from "@ctsu/loader";
import { useCurrentUser } from "helpers/getAppConfig";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAffilationLov,
  participantsSelector,
  selectedMCSelector,
  selectedPRSelector
} from "stores/redux/slice/manageCommitte";
import EditRow from "./EditRow";

const statusLov = [
  {
    label: "Active",
    value: "Active"
  },
  {
    label: "Inactive",
    value: "Inactive"
  }
];

export function ParticipantsGrid(
  { rows, association, roleType, roleName, objectType, roleId, objId, owner, statusOfMC, hasEditPermission }
) {
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const columns = [
    {
      filter: true,
      label: "Owner",
      name: "group",
      title: "Owner"
    },
    {
      filter: true,
      label: "Person CTEP ID",
      name: "personCtepId",
      title: "Person CTEP ID"
    },
    {
      filter: true,
      label: "Name",
      name: "personName",
      title: "Name"
    },
    {
      filter: true,
      label: "Site CTEP ID",
      name: "siteCtepId",
      title: "Site CTEP ID"
    },
    {
      filter: true,
      label: "Status",
      name: "esysStatus",
      options: statusLov,
      title: "Status",
      type: "object"
    },
    {
      filter: true,
      label: "Status Date",
      name: "esysStatusDate",
      title: "Status Date",
      type: "date"
    }
  ];
  return (
    <section className="mc-participants-grid">
      <GridTable
        user={currentUser}
        id="mcParticipants"
        rows={rows}
        title={`Participants for ${association || ""} with the ${roleType || ""} ${roleName || ""} Role for ${objectType || ""
          } Objects`}
        columns={columns}
        toPdf={false}
        filterable
        enableInfiniteScroll={false}
        sortable
        showFilterByDefault
        enableToolbar
        highlightRow={0}
        recordPerPage={10}
        getToken={getToken}
        tag="my-mcp-browser"
        editable
        allowAddRow
        rowEditable={() => hasEditPermission}
        editMode={hasEditPermission && roleId}
        addRowLabel="Participant"
        addRowTitle="Add a Participant"
        defaultSorts={[{ field: "group", dir: "asc" }, { field: "personName", dir: "asc" }]}
        generateToolTip={(rowData) => `Edit ${rowData.personName}.`}
        renderEditRow={(row, setEditing) => {
          if (row.perId) {
            dispatch(fetchAffilationLov({ ...row, owner }));
          }
          return (
            <EditRow
              key={owner}
              row={row}
              setEditing={setEditing}
              existingRecord={rows}
              roleId={roleId}
              objId={objId}
              objectType={objectType}
              owner={owner}
              statusOfMC={statusOfMC}
            />
          );
        }}
      />
    </section>
  );
}

export default function Participants({ hasEditPermission }) {
  const selectedMC = useSelector(selectedMCSelector);
  const selectedPR = useSelector(selectedPRSelector);
  const res = useSelector(participantsSelector);
  return (
    <ParticipantsGrid
      rows={res?.data || []}
      association={selectedMC?.esysId}
      roleType={selectedPR?.roleType}
      roleName={selectedPR?.roleName}
      roleId={selectedPR?.roleId}
      objectType={selectedMC?.objectType}
      objId={selectedMC?.id}
      statusOfMC={selectedMC?.esysStatus}
      owner={selectedMC?.owner}
      key={`${selectedMC?.id}-${selectedMC?.owner}-${selectedPR?.roleId}`}
      hasEditPermission={hasEditPermission}
    />
  );
}
